import gql from 'graphql-tag';

export default gql`
  mutation($input: SignInWithSSOInput!) @api(name: "auth") {
    signInWithSSO(input: $input) {
      data {
        user {
          id
          email
          username
          phone
          document
        }
        # customDomain
        customFields
      }
      conflict {
        items {
          id
          document
          email
        }
        consultantId
      }
      organizationId
      token
    }
  }
`;

export type SignInWithSSOVariables = {
  input: {
    provider: 'MaryKay';
    code: string;
    codeVerifier: string;
  };
};

export type SignInWithSSOResponse = {
  signInWithSSO: {
    data: {
      user: User;
      customFields: { key: string; value: string }[];
    };
    conflict?: {
      items: {
        id: string;
        document: string;
        email: string;
      }[];
      consultantId: string;
    };
    organizationId: string;
    token?: string;
  };
};
